import React, { memo, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../../../assets/css/dashboard.css';
import * as Icon from 'react-feather';
import { toast } from 'react-toastify';
import Loader from 'components/widgets/loader/ComponentLoader';
import Moment from 'react-moment';
import { acceptAppointmentRequest, rejectAppointmentRequest } from 'services/appointmentSrv';
import { useQueryClient } from 'react-query';

const ViewAppointment = (props) => {
  const { data = [], isLoading, isError, isSuccess, onHide, appointmentShow } = props;
  const [isProcessing, setIsProcessing] = useState(false);
  const queryClient = useQueryClient();

  useEffect(() => {
  if (appointmentShow) {
    queryClient.invalidateQueries({ queryKey: ['appointments'] });
  }
}, [appointmentShow, queryClient]);

  const handleAcceptance = async () => {
    if (!data?.appointmentSystemRef) {
      toast.error('Invalid appointment reference.');
      return;
    }
    setIsProcessing(true);
    try {
      await acceptAppointmentRequest(data.appointmentSystemRef);
      toast.success('Appointment accepted successfully!');
      onHide();
    } catch (error) {
      console.error('Acceptance error:', error);
      toast.error(`Failed to accept appointment: ${error.message}`);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleRejection = async () => {
    if (!data?.appointmentSystemRef) {
      toast.error('Invalid appointment reference.');
      return;
    }
    setIsProcessing(true);
    try {
      await rejectAppointmentRequest(data.appointmentSystemRef, 'Rejected by the intermediary');
      toast.success('Appointment rejected successfully!');
      onHide();
    } catch (error) {
      console.error('Rejection error:', error);
      toast.error(`Failed to reject appointment: ${error.message}`);
    } finally {
      setIsProcessing(false);
    }
  };

  const isButtonDisabled = isProcessing || !data?.appointmentSystemRef;

  return (
    <div>
      <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Appointment Details</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading && <Loader />}
          {isError && <p>OOPS! Something went wrong!</p>}
          {isSuccess && data ? (
            <>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <div className="row">
                    <div className="col-md-1">
                      <Icon.User size={20} />
                    </div>
                    <div className="col-md-11">
                      {data?.clientDetails?.name}{' '}
                      
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mb-3">
                  <div className="row">
                    <div className="col-md-1">
                      <Icon.Phone size={20} />
                    </div>
                    <div className="col-md-11">{data?.clientDetails?.phone}</div>
                  </div>
                </div>
                <div className="col-md-12 mb-3">
                  <div className="row">
                    <div className="col-1">
                      <Icon.Mail size={20} />
                    </div>
                    <div className="col-11">{data?.clientDetails?.email}</div>
                  </div>
                </div>
                <div className="col-md-12 mb-3">
                  <div className="row">
                    <div className="col-1">
                      <Icon.Briefcase size={20} />
                    </div>
                    <div className="col-11">Underwriter</div>
                  </div>
                </div>
                <div className="col-md-12 mb-3">
                  <div className="row">
                    <div className="col-md-1">
                      <Icon.Clock size={20} />
                    </div>
                    <div className="col-md-11">
                      <Moment format="DD-MMM-YYYY">{data?.appointmentDate}</Moment>
                      <span className="d-block">
                        ~ <Moment format="HH:mm a">{data?.appointmentTime}</Moment>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mb-3">
                  <div className="row">
                    <div className="col-md-1">
                      <Icon.Map size={20} />
                    </div>
                    <div className="col-md-11">Appointment Location</div>
                  </div>
                </div>
                <div className="col-md-12 mb-3">
                  <div className="row">
                    <div className="col-md-1">
                      <Icon.FileText size={20} />
                    </div>
                    <div className="col-md-11">{data?.message}</div>
                  </div>
                </div>
              </div>
              {(data.createdBy === "CLIENT" && data.status === "PENDING") && (
                <div className="d-flex justify-content-between gap-4">
                <button
                  onClick={handleRejection}
                  disabled={isButtonDisabled}
                  className="btn btn-outline-danger px-4"
                >
                  {isProcessing ? 'Processing...' : 'Reject'}
                </button>
                <button
                  onClick={handleAcceptance}
                  disabled={isButtonDisabled}
                  className="btn btn-outline-success px-4"
                >
                  {isProcessing ? 'Processing...' : 'Accept'}
                </button>
              </div>
              )}
           
            </>
          ) : (
            !isLoading && <p>No appointment data available.</p>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default memo(ViewAppointment);